<template>
  <div id="userForm">
    <div class="col s12 l6 input-field z ">
        <input type="text" name="first_name" class="validate" id="first_name" v-model="user.first_name">
        <label for="first_name"><span>First Name</span></label>
        <span class="helper-text" data-error="Error" data-success="Valid">Requierd Field</span>
    </div>
    <div class="col s12 l6 input-field z">
        <input type="text" name="last_name" class="validate" id="last_name" v-model="user['last_name']">
        <label for="last_name"><span>Last Name</span></label>
        <span class="helper-text" data-error="Error" data-success="Valid">Requierd Field</span>
    </div>
    <div class="col s12 l6 input-field z">
        <input  type="text" name="position" id="position" v-model="user['position']">
        <label for="position"><span>Position</span></label>
        
    </div>
    <div class="col s12 l6 input-field z">
        <input type="text" name="role" id="role" v-model="user['role']">
        <label for="role"><span>Role</span></label>
    </div>
    <div class="col s12 z">
      <small-complete
        list-key="name"
        @update="$_setCountry($event)"
        :list-data="c">
        Country
      </small-complete>
    </div>
    <div class="col s12 input-field z">
       <textarea name="address" v-model="user['address']" class="materialize-textarea"></textarea>
      <label for="address">Address </label>
    </div>
    <div class="col s12 z">
      <small-complete
        list-key="name"
        :default-text="selectedCompany ? selectedCompany.title.rendered : ''"
        @update="$_selectCompany($event)"
        :list-data="dataCompanies.length > 0 ? dataCompanies : new Array">
        Company / Organization
      </small-complete>
    </div>
    <div class="col s12  input-field z">
        <input type="email" name="email" id="email" v-model="user['email']">
        <label for="email"><span>Email</span></label>
    </div>


    <div class="col s12">
      <button 
      :disabled="gd"
      @click="$_createUser()" class="btn col s12 blue accent-4 btn-medium waves-effect">Add Person</button>
    </div>
    <div class="col s12">
      <br>
    </div>
  </div>
</template>
<script>
import core from '@/functions'

import contentService from '@/services/contentService'
import smallComplete from '@/components/records/fields/autoComplete.component'
const sortPhunction = arr => {
  return arr.sort(function(a, b) {
    let textA = a.name.toLowerCase();
    let textB = b.name.toLowerCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
};
export default {
  name:'newUser',
  props:{
    selectedCompany:{
      type:[Object, Boolean]
    },
    dataCompanies:{
      type:Array,
    },
    dataUsers:{
      type:Array,
    }
  },
  components:{
    smallComplete
  },
  data(){
    return {
      gd:false,
       countrySelect: {
        field_type: "inputField",
        v: true,
        type: "select",
        label: "Country",
        values: "",
        name: "country",
        options: sortPhunction(core.countries)
        },
      user:{
        first_name:'',
        last_name:'',
        position:'',
        role:'',
        country:'',
        address:'',
        company:''
      }
    }
  },
  watch:{
    selectedCompany:function(nV){
      if(nV)
      this.user['company'] = nV.id
    }
  },
  computed:{
      validateForm: {
      get() {
        let unitTest = prop => {
          return prop.split('').length > 3;
        };
/*         let selectTest = prop => {
          return prop.values !== "" ? true : false;
        };
        let emailTest = prop => {
          return prop.values == ""
            ? ""
            : this.reg.test(prop.values)
            ? true
            : false;
        }; */
        let textFields = Object.values(this.user)
          .map(item => item)
          .every(unitTest)

        return textFields ? true : false;
      }
      },
     c:{
      get(){
        return core.countries
      }
    }
  },
  methods:{
    $_selectCompany(evt){
      this.user['company'] = evt.id
    },
    $_setCountry(evt){
      this.user['country'] = evt.name
    },
    $_createUser(){
       this.gd = true
      let payload = {
        title:`${this.user.first_name} ${this.user.last_name}`,
        status:'publish',
        fields:{
          first_name:this.user.first_name,
          last_name:this.user.last_name,
          position:this.user.position,
          role:this.user.role,
          email:this.user.email,
          company:this.user.company,
          country:this.user.country,
          address:this.user.address
        }
      }
      contentService.saveRecordUser(payload)
      .then(res =>{
        this.gd = false
        this.$store.commit('ADD_NEW_USER',res.data)
        this.$emit('update',{action:'success', data:res.data})
        core.toastMessage('New User Added')
      })
      .catch(err=> {
        core.toastMessage(`Error contact administrator`, ()=>{ window.warn(err)})
      })
      
    }
  }
}
</script>